var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"message"},[_vm._v("Congratulations!")]),_c('div',{staticClass:"description"},[_vm._v("You have punished all bad-sisisins.")])])
}]

export { render, staticRenderFns }